
import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getTvLaneTreeStart = () => {
    return {
        type: actionTypes.TVLANES_GET_PROJECT_TREE_START
    };
};

export const getTvLaneTreeSuccess = (children) => {
    return {
        type: actionTypes.TVLANES_GET_PROJECT_TREE_SUCCESS,
        children: children
    };
};

export const getTvLaneTreeFail = (error) => {
    return {
        type: actionTypes.TVLANES_GET_PROJECT_TREE_FAIL,
        error: error
    };
};

export const updateTVLaneObjectsSuccess = (data) => {
    return {
        type: actionTypes.TVLANES_UPDATE_OBJECTS_SUCCESS,
        payload: data
    }
}

export const updateTvLaneObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateLaneObjectsSuccess(obj));
    }
}


export const addWorkToTvLane = ({ laneId, workId }) => {
    return ((dispatch, getState) => {
        console.log("LOGS: LAMTEST addWorkToTvLane laneId workIds", laneId, workId);
        if (window.flow.sdkTvAdmAddWerkToLane) {
            window.flow.sdkTvAdmAddWerkToLane(laneId, workId)
                .then(res => {
                    console.log("LOGS: LAMTEST addWorkToTvLane res", res);
                    dispatch(actions.getTvLaneTree());
                })
                .catch(error => {
                    console.log("LOGS: LAMTEST addWorkToTvLane error", error);
                });
        }

    })
}

export const removeWorkFromTvLane = ({ laneId, workId }) => {
    return ((dispatch, getState) => {
        console.log("LOGS: LAMTEST removeWorkFromTvLane laneId workIds", laneId, workId);
        window.flow.sdkTvAdmRemoveWerkFromLane(laneId, workId)
            .then(res => {
                console.log("LOGS: LAMTEST removeWorkFromTvLane res", res);
                dispatch(actions.getTvLaneTree());
            })
            .catch(error => {
                console.log("LOGS: LAMTEST removeWorkFromTvLane error", error);
            });
    })
}

//LANE TREE
export const getTvLaneTree = () => {
    return dispatch => {
        dispatch({ type: actionTypes.TVLANES_SET_LOADING, payload: { loading: true } });
        dispatch(getTvLaneTreeStart());
        window.flow.sdkTvAdmGetRoot().then(res => {
            console.log("LOGS: LAMTEST: getTvLaneTree res", res);
            dispatch(getTvLaneTreeSuccess(res.children));
            dispatch({ type: actionTypes.TVLANES_SET_LOADING, payload: { loading: false } });
        }).catch(res => {
            dispatch(getTvLaneTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
            dispatch({ type: actionTypes.TVLANES_SET_LOADING, payload: { loading: false } });
        });
    };
};

export const saveTvNewLane = (data) => {
    console.log("LOGS: LAMTEST saveTvNewLane", data);
    return (dispatch => {
        window.flow.sdkTvAdmCreateLane({ 'title': data })
            .then(res => {
                console.log("LAMTEST saveTvNewLane RES", res);
                dispatch(getTvLaneTree());
            })
            .catch(err => console.log("LAMTEST saveNewLane err", JSON.stringify(err)))
    })
}

export const editTvLane = ({ laneId, userInputs }) => {
    console.log("LOGS: LAMTEST editTvLane", laneId);
    console.log("LOGS: LAMTEST userInputs", userInputs);
    return (dispatch => {
        window.flow.sdkTvAdmEditLane(laneId, { ...userInputs })
            .then(res => {
                console.log("LAMTEST editTvLane RES", res);
                dispatch(getTvLaneTree());
            })
            .catch(err => console.log("LAMTEST editTvLane err", JSON.stringify(err)))
    })
}

export const deleteTvLane = ({ laneId }) => {
    console.log("LOGS: LAMTEST deleteTvLane laneId", laneId);
    return (dispatch => {
        window.flow.sdkTvAdmDeleteLane(laneId)
            .then(res => {
                console.log("LAMTEST deleteTvLane RES", res);
                dispatch(getTvLaneTree());
            })
            .catch(err => console.log("LAMTEST deleteTvLane err", JSON.stringify(err)))
    })
}


export const updateMediaObjectsSuccess = (data) => {
    return {
        type: actionTypes.TVLANES_UPDATE_MEDIAOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateMediaObjects = (obj) => {
    return (dispatch) => {
        dispatch(updateMediaObjectsSuccess(obj));
    }
}
